export default __webpack_public_path__ + "static/media/B45D.d15931ad.jpg";